import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../context';

interface ErrorHandlerOptions {
  redirectTo?: string;
  redirectDelay?: number;
}

/**
 * A hook that shows toast notifications for errors and optionally redirects
 */
export const useErrorHandler = (
  error: string | null, 
  options: ErrorHandlerOptions = {}
) => {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const { redirectTo, redirectDelay = 2000 } = options;

  useEffect(() => {
    if (error) {
      showToast(error, 'error');
      
      if (redirectTo) {
        setTimeout(() => {
          navigate(redirectTo);
        }, redirectDelay);
      }
    }
  }, [error, showToast, navigate, redirectTo, redirectDelay]);

  return null;
};

export default useErrorHandler; 